import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Money } from "./SaudiRiyal";
import { api } from "../lib/api";

const Row = ({ u, emps, onLinked }) => {
  const [eid, setEid] = useState("");
  const [busy, setBusy] = useState(false);
  const link = async () => {
    const e = emps.find((x) => x.id === eid);
    if (!u.platform?.includes("كيتا") && e?.rider_id && e.rider_id !== u.rider_id && !window.confirm(`الموظف ${e.name} لديه رقم معرّف سابق (${e.rider_id}). سيُستبدل بالرقم ${u.rider_id}. متابعة؟`)) return;
    setBusy(true);
    try { await api.linkRiderId(u.rider_id, eid, u.platform); toast.success(`تم ربط ${u.rider_id} بـ ${e?.name}`); onLinked(); }
    catch (err) { toast.error(err?.response?.data?.detail || "تعذّر الربط"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 px-3 py-2" data-testid={`link-row-${u.rider_id}`}>
      <span className="w-24 font-mono text-sm text-slate-800" dir="ltr">{u.rider_id}</span>
      <span className="w-24 text-xs text-slate-500">{u.info ?? <><Money value={u.net} /> · {u.orders} طلب</>}</span>
      {u.platform && <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] text-slate-600" data-testid={`link-platform-${u.rider_id}`}>{u.platform}{u.name ? ` · ${u.name}` : ""}</span>}
      <select value={eid} onChange={(e) => setEid(e.target.value)} className="h-9 min-w-0 basis-full sm:basis-auto flex-1 rounded-lg border border-slate-200 bg-white px-2 text-sm" data-testid={`link-select-${u.rider_id}`}>
        <option value="">اختر الموظف…</option>
        {emps.map((e) => <option key={e.id} value={e.id}>{e.name}{e.rider_id ? ` (${e.rider_id})` : ""}</option>)}
      </select>
      <Button size="sm" disabled={!eid || busy} onClick={link} className="gap-1 bg-indigo-600 hover:bg-indigo-700" data-testid={`link-btn-${u.rider_id}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Link2 className="h-4 w-4" />} ربط
      </Button>
    </div>
  );
};

export const RiderIdLinker = ({ unmatched, onLinked, title }) => {
  const [emps, setEmps] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (open && !emps.length) api.listEmployees().then((r) => setEmps((Array.isArray(r) ? r : r.items || []).map((e) => ({ id: e.id, name: e.name, rider_id: e.rider_id || "" })).sort((a, b) => a.name.localeCompare(b.name, "ar")))).catch(() => {});
  }, [open, emps.length]);
  if (!unmatched?.length) return null;
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50/50" data-testid="rider-id-linker">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between p-3 text-sm font-semibold text-amber-800" data-testid="rider-id-linker-toggle">
        <span className="flex items-center gap-1.5"><Link2 className="h-4 w-4" /> {title || `${unmatched.length} رقم معرّف في الفاتورة غير مربوط بموظف`}</span>
        <span className="text-xs">{open ? "إخفاء" : "ربط الآن"}</span>
      </button>
      {open && <div className="max-h-96 divide-y divide-amber-100 overflow-y-auto border-t border-amber-100 bg-white">{unmatched.map((u) => <Row key={u.rider_id} u={u} emps={emps} onLinked={onLinked} />)}</div>}
    </div>
  );
};
